import unescape from 'lodash/unescape';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import IconMarker from '@spothero/icons/marker';
import Button from '@spothero/ui/button';
import Select from '@spothero/ui/select';
import {setSortType} from 'search/search-actions';
import SegmentUtils from 'utils/segment';
import SpotUtils from 'utils/spot';

const SORT_OPTIONS = [
    {
        label: 'Featured',
        value: SpotUtils.airportSortValues.FEATURED,
    },
    {
        label: 'Shuttle Time',
        value: SpotUtils.airportSortValues.SHUTTLE_TIME,
    },
    {
        label: 'Price',
        value: SpotUtils.airportSortValues.PRICE,
    },
    {
        label: 'Location Name',
        value: SpotUtils.airportSortValues.ALPHABETICAL,
    },
];

class SearchAirportSort extends Component {
    static propTypes = {
        destinationTitle: PropTypes.string.isRequired,
        sortBy: PropTypes.string,
        spotCount: PropTypes.number.isRequired,
        onChangeSort: PropTypes.func.isRequired,
        onToggleViewType: PropTypes.func.isRequired,
    };

    componentDidMount() {
        SegmentUtils.track({
            event: 'List Landing',
        });
    }

    _onSortChange = ({value}) => {
        this.props.onChangeSort(value);
    };

    _displaySpotCount(spotCount) {
        return `${spotCount > 0 ? `${spotCount} ` : ''}Parking Spot${
            spotCount === 1 ? '' : 's'
        }`;
    }

    render() {
        const {
            destinationTitle,
            spotCount,
            sortBy,
            onToggleViewType,
        } = this.props;

        return (
            <div className="SearchAirportSort">
                <div className="SearchAirportSort-form">
                    <Select
                        defaultValue={sortBy}
                        onChange={this._onSortChange}
                        items={SORT_OPTIONS}
                    />
                    <Button
                        color="tertiary"
                        iconPosition="right"
                        onClick={onToggleViewType}
                    >
                        View Map <IconMarker />
                    </Button>
                </div>
                <div className="SearchAirportSort-count">
                    <strong>{this._displaySpotCount(spotCount)}</strong> Near{' '}
                    <strong>{unescape(destinationTitle)}</strong>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {
        search: {
            data: {sortBy},
        },
        destination: {
            data: {title: destinationTitle},
        },
    } = state;

    return {
        destinationTitle,
        sortBy,
    };
};

const mapDispatchToProps = {
    onChangeSort: setSortType,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SearchAirportSort);
